import { Component, ChangeDetectionStrategy, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppService } from '@services/app.service';
import { environment } from 'src/environments/environment';
import { ApiService } from '@services/api.service';
import { AuthRow } from 'auxilium-connect';
import { LanguageDef } from 'src/lang';


import { FormControl, FormGroup } from '@angular/forms'; // this can be removed also


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

	/**
	 * this can get removed
	 */
	dynamicQrCode = new FormControl('https://tinyurl.com/49bd3962');

	upcCode = new FormControl('600586009123');
	upcCodeConfig: JsBarcode.Options = {
		format: 'upc',
		displayValue: true,
	}

	dateTimeForm = new FormGroup({
		date: new FormControl(),
		dateTime: new FormControl(),
		time: new FormControl(),
	})

	/**
	 * /end of removable code
	 */



	readonly env = environment;
	spoke: string;
	auth: AuthRow;
	language: keyof LanguageDef;

	constructor(
		public app: AppService,
		private _api: ApiService,
		private _cd: ChangeDetectorRef,
	) {
		this.language = app.language;

		// this check can be removed, as well as the code if need be, its
		// only here for convenience
		this._api
			.fetchInterfaces()
			.subscribe();
	}

	// testConfirm() {
	// 	this.app.confirm({
	// 		message: 'do you want to do the thing?',
	// 		title: 'this is a title',
	// 		translate: true
	// 	}).subscribe(resp => {
	// 		console.warn('responded', resp);
	// 	})
	// }

	changeLanguage(to: keyof LanguageDef) {
		this.app.changeLanguage(to);
		this.language = to;
		this._cd.detectChanges();
	}

	logout() {
		this._api.logout().subscribe(resp => this._cd.detectChanges());
	}

	ngOnInit() {

		this._checkTitle();

		this.app.auth.subscribe(a => this.auth = a); // needed for the user menu
		this.spoke = this._api.spoke; // needed for the user menu also

	}

	private _checkTitle() {

		const chunks = this.app.title.getTitle().split('**'),
			len = chunks.length;
		if (len === 3 && !chunks[0] && !chunks[len - 1]) {
			console.warn('your app title has no been set - please edit the index.html');
		}
	}
}
